var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { ["add-user-popup"]: true, ["hide"]: !_vm.display } },
    [
      _c("div", { ref: "addUserPopupRef", staticClass: "popup" }, [
        _c("div", { staticClass: "title-section" }, [
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("dash.settings.users.header.add_user"))),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm
                  .$t("dash.settings.add_user.subtitle")
                  .replace("%", _vm.stateCarrousel)
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "container-carrousel" }, [
          _c("div", { class: "carrousel state" + _vm.stateCarrousel }, [
            _c("div", { staticClass: "slide slide1" }, [
              _c("div", { staticClass: "container-input name" }, [
                _c("div", { staticClass: "inputs" }, [
                  _c("div", { staticClass: "container-input" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("dash.settings.add_user.firstname.label"))
                      ),
                    ]),
                    _c("div", { staticClass: "input" }, [
                      _c("i", { staticClass: "fa-regular fa-circle-user" }),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.firstname,
                            expression: "form.firstname",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t(
                            "dash.settings.account.name.first_name.placeholder"
                          ),
                        },
                        domProps: { value: _vm.form.firstname },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "firstname", $event.target.value)
                          },
                        },
                      }),
                      _vm.error.firstname
                        ? _c(
                            "div",
                            { staticClass: "containerError" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    position: "top",
                                    text: _vm.error.firstname,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-regular fa-circle-exclamation",
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "container-input" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("dash.settings.add_user.lastname.label"))
                      ),
                    ]),
                    _c("div", { staticClass: "input" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.lastname,
                            expression: "form.lastname",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t(
                            "dash.settings.account.name.last_name.placeholder"
                          ),
                        },
                        domProps: { value: _vm.form.lastname },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "lastname", $event.target.value)
                          },
                        },
                      }),
                      _vm.error.lastname
                        ? _c(
                            "div",
                            { staticClass: "containerError" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    position: "top",
                                    text: _vm.error.lastname,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-regular fa-circle-exclamation",
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "container-input email" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("dash.settings.account.email.title"))),
                ]),
                _c("div", { staticClass: "input" }, [
                  _c("i", { staticClass: "fa-regular fa-at" }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.email,
                        expression: "form.email",
                      },
                    ],
                    attrs: { placeholder: "Entrez une adresse Email" },
                    domProps: { value: _vm.form.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "email", $event.target.value)
                      },
                    },
                  }),
                  _vm.error.email
                    ? _c(
                        "div",
                        { staticClass: "containerError" },
                        [
                          _c(
                            "Tooltip",
                            {
                              attrs: { position: "top", text: _vm.error.email },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular fa-circle-exclamation",
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _c("div", { staticClass: "container-input pasword" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("dash.settings.account.password.title"))
                  ),
                ]),
                _c("div", { staticClass: "input" }, [
                  _c("i", { staticClass: "fa-regular fa-key" }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.password,
                        expression: "form.password",
                      },
                    ],
                    attrs: {
                      placeholder: _vm.$t(
                        "dash.settings.add_user.password.placeholder"
                      ),
                    },
                    domProps: { value: _vm.form.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "password", $event.target.value)
                      },
                    },
                  }),
                  _vm.error.password
                    ? _c(
                        "div",
                        { staticClass: "containerError" },
                        [
                          _c(
                            "Tooltip",
                            {
                              attrs: {
                                position: "top",
                                text: _vm.error.password,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular fa-circle-exclamation",
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "slide slide2" }, [
              _c("div", { staticClass: "container-input role" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("dash.settings.users.legend.role"))),
                ]),
                _c(
                  "div",
                  { staticClass: "input" },
                  [
                    _c("SelectComponent", {
                      attrs: {
                        changeValueSelect: _vm.changeRole,
                        data: _vm.getDataSelectRole(),
                        valueSelect: _vm.form.role,
                        positionY: "bottom",
                        positionAuto: false,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "container-input notifications" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("dash.settings.add_user.notifications.title"))
                  ),
                ]),
                _c("div", { staticClass: "box" }, [
                  _vm.form.role !== "Viewer"
                    ? _c(
                        "div",
                        { staticClass: "notification" },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "dash.settings.add_user.notifications.echec.description"
                                )
                              ) +
                              ".\n                                "
                          ),
                          _c("ComponentSwitch", {
                            attrs: {
                              value: _vm.form.alertEchec,
                              onChange: _vm.handleChangeAlert,
                              id: "alertEchec",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "notification" },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "dash.settings.add_user.notifications.validation.description"
                            )
                          ),
                        },
                      }),
                      _c("ComponentSwitch", {
                        attrs: {
                          value: _vm.form.alertValidation,
                          onChange: _vm.handleChangeAlert,
                          id: "alertValidation",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.form.role !== "Viewer"
                    ? _c(
                        "div",
                        { staticClass: "notification" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "dash.settings.add_user.notifications.inbox.description"
                                )
                              ),
                            },
                          }),
                          _c("ComponentSwitch", {
                            attrs: {
                              value: _vm.form.alertInbox,
                              onChange: _vm.handleChangeAlert,
                              id: "alertInbox",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.role !== "Viewer"
                    ? _c(
                        "div",
                        { staticClass: "notification" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "dash.settings.add_user.notifications.page.description"
                                )
                              ),
                            },
                          }),
                          _c("ComponentSwitch", {
                            attrs: {
                              value: _vm.form.alertPage,
                              onChange: _vm.handleChangeAlert,
                              id: "alertPage",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.role !== "Viewer"
                    ? _c(
                        "div",
                        { staticClass: "notification" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "dash.settings.add_user.notifications.source.description"
                                )
                              ),
                            },
                          }),
                          _c("ComponentSwitch", {
                            attrs: {
                              value: _vm.form.alertSource,
                              onChange: _vm.handleChangeAlert,
                              id: "alertSource",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "slide slide3" }, [
              _c(
                "div",
                { staticClass: "container-select-page" },
                [
                  _c("SelectPageComponenent", {
                    attrs: {
                      groups: _vm.groups,
                      allPages: _vm.allPages,
                      SelectPageProp: _vm.SelectPage.reduce((acc, id) => {
                        _vm.allPages[id] && acc.push(_vm.allPages[id])
                        return acc
                      }, []),
                    },
                    on: { updateSelectPage: _vm.updateSelectPage },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "list-page-select hide-scrollbar" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("dash.settings.add_user.page_select"))),
                ]),
                _c(
                  "div",
                  { staticClass: "list-avatar" },
                  _vm._l(
                    _vm.SelectPage.filter((p) => _vm.findPage(p)),
                    function (pageId) {
                      return _c(
                        "Tooltip",
                        {
                          key: pageId,
                          attrs: {
                            position: "top",
                            text: _vm.findPage(pageId).name,
                          },
                        },
                        [
                          _c("Avatar", {
                            key: pageId,
                            attrs: {
                              checked: true,
                              id: pageId,
                              urlPicture: _vm.findPage(pageId).avatar,
                              typeNetwork: _vm.findPage(pageId).network,
                            },
                            on: { click: _vm.removeSelectPage },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  1
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "btns" }, [
          _vm.stateCarrousel > 1
            ? _c(
                "div",
                {
                  staticClass: "btn-outline-primary",
                  on: { click: _vm.previousStade },
                },
                [_vm._v(_vm._s(_vm.$t("dash.settings.add_user.previous")))]
              )
            : _c(
                "div",
                {
                  staticClass: "btn-outline-primary",
                  on: { click: _vm.cancel },
                },
                [_vm._v(_vm._s(_vm.$t("dash.settings.add_user.cancel")))]
              ),
          _vm.stateCarrousel < 3
            ? _c(
                "div",
                {
                  staticClass: "btn-primary icon-r",
                  on: { click: _vm.nextState },
                },
                [_vm._v(_vm._s(_vm.$t("dash.settings.add_user.next")))]
              )
            : _c(
                "div",
                { staticClass: "btn-primary icon-r", on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("dash.settings.add_user.save")))]
              ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }